import { c as _c } from "react/compiler-runtime";
import { Position } from '@xyflow/react';
import { cx } from 'class-variance-authority';
import useSidebar from '../hooks/use-sidebar';
import { EDGE_LABEL_AND_NODE_Z_INDEX } from '../playbook-builder.constants';
import type { NodeProps } from '../playbook-builder.types';
import CustomHandle from './custom-handle';
export const EdgeLabelNode = t0 => {
  const $ = _c(10);
  const {
    id,
    data
  } = t0;
  let t1;
  if ($[0] !== id) {
    t1 = <CustomHandle type="target" position={Position.Top} id={id} />;
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data.label) {
    t2 = <LabelNode label={data.label} />;
    $[2] = data.label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== id) {
    t3 = <CustomHandle type="source" position={Position.Bottom} id={id} />;
    $[4] = id;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="relative flex items-center justify-center w-[180px] h-[28px] min-w-[180px] min-h-[28px] max-w-[180px] max-h-[28px]">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export const LabelNode = t0 => {
  const $ = _c(6);
  const {
    label
  } = t0;
  const {
    isAnyOpen
  } = useSidebar();
  let t1;
  if ($[0] !== isAnyOpen) {
    t1 = cx(["inline-flex justify-center items-center gap-0.5 py-1 px-2 border-[1.5px] min-h-[24px] min-w-[48px] border-solid border-primary rounded-full bg-primary text-caption-4 text-tertiary nodrag nopan text-nowrap", {
      "before:content-[\"\"] before:absolute before:inset-0 before:bg-secondary before:opacity-20 before:rounded-full": isAnyOpen
    }]);
    $[0] = isAnyOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      position: "absolute",
      pointerEvents: "all",
      zIndex: EDGE_LABEL_AND_NODE_Z_INDEX
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = label || "...";
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <div className={t1} style={t2}>{t3}</div>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};